<template>
    <div>
        <Collapse v-model="value" simple style="border:0">
            <Panel name="1" hide-arrow style="margin: 20px 0;border:0" >
                <FormTitle :titleText="$t('Position_Info')"/><!-- 职位信息 -->
                <div slot="content" style="margin-top: 40px;">
                    <Table border :loading="loading" :columns="columns" :data="data"> </Table>
                    <div style="margin:20px 0;">
                        <Page style="float: right" :total="total" @on-change="pageChange"/>
                    </div>
                </div>
            </Panel>
            <div  v-if="id==''">
                <span style="color: red;">{{$t('EmpFilesComment')}}</span>
            </div> 
        </Collapse>
       
    </div>
</template>

<script>
import axios from 'axios'
import DateUtil from "@/util/DateUtil";
export default {
    data(){
        return{
            formItem:{},
            list:[],
            value:[1],
            date: new DateUtil(),
            loading:false,
            pageInfo: {
                itemCount: 0,
                pageNo: 1,
                pageSize: 10,
            },
            total: 0,
            data:[],
            id:'',
            serialnumber:''
        }
    },
    computed:{
        columns(){
            return [
                {
                    title: this.$t('Position_Name_Chinese'),/* 职务描述(中文) */
                    key: "positionCTitle",
                    align: "center",
                    minWidth: 120,
                    ellipsis:true,
                    
                },
                {
                    title: this.$t('Position_Name_English'),/* 职务描述(英文) */
                    key: "positionETitle",
                    align: "center",
                    minWidth: 120,
                    
                },{
                    title: this.$t('Position_Start_Date'),/* 职位开始日 */
                    key: "positionStartDate",
                    align: "center",
                    minWidth: 120,
                    ellipsis:true,
                    render: (h, params) => {
                        return h(
                            "span",
                            this.date.dateVal(params.row.positionStartDate, "YYYY-MM-DD")
                        );
                    },
                },{
                    title: this.$t('Line_Manager'),/* 直线主管 */
                    key: this.lang=='zh'?"dirSupUserName":"dirSupUserEName",
                    align: "center",
                    minWidth: 120,
                    ellipsis:true,
                },{
                    title: this.$t('Line_Manager_Position'),/* 直线主管职位 */
                    key: this.lang=='zh'?"dirSupPosition":"dirSupPositionEname",
                    align: "center",
                    minWidth: 120,
                },{
                    title: this.$t('Dotted-Line_Manager'),/* 虚线主管 */
                    key: this.lang=='zh'?"indirSupUserName":"indirSupUserEName",
                    align: "center",
                    minWidth: 120,
                    ellipsis:true,
                },{
                    title: this.$t('Dotted-Line_Manager_Position'),/* 虚线主管职位 */
                    key: this.lang=='zh'?"indirSupPosition":"indirSupPositionEName",
                    align: "center",
                    minWidth: 120,
                },
            ]
        },
        lang(){
            return this.$store.getters.selectLangeData
        }
    },
    methods:{
        getData(val){
            this.loading=true
            val?this.serialnumber=val:this.serialnumber=JSON.parse(sessionStorage.getItem("userInfo")).serialnumber
            axios.post("/employeeInformation/selectEmployeePosition", {...this.pageInfo,serialnumber:this.serialnumber}).then((res) => {
                this.loading=false
                if (res) {
                   this.data=res.data
                   this.total=parseInt(res.pageInfo.total)
                }
            })
        },
        pageChange(val){
            this.pageInfo.pageNo = val
            this.getData(this.serialnumber)
        },
    }
}
</script>

<style lang="less" scoped>
.btnfooter {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/process/files/components/PositionInformation.vue